import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';

// Bunch of info that just won't change throughout a game,
// at least not during a user session.
const getGameStaticDataHelper = (state) => {
    const {
        gumbo: {
            gameData: {
                teams = {},
                datetime = {},
                game = {},
                venue = {},
                probablePitchers = {}
            } = {}
        } = {}
    } = state || {};

    return {
        ...game,
        probablePitchers,
        venue,
        teams,
        datetime,
        gamePk: game.pk // use for equality check in createGamePkSelector
    };
};

// Custom selector factory that won't invalidate unless the gamePk has changed
// Requires gamePk be in the return state object
export const createGamePkSelector = createSelectorCreator(defaultMemoize, ({ gamePk }, { gamePk: previousGamePk } = {}) => {
    return typeof gamePk !== 'undefined' && gamePk === previousGamePk;
});

export const getGameStaticData = createGamePkSelector(
    [getGameStaticDataHelper],
    (gameStaticData) => gameStaticData
);
